!function () {
  'use strict';

  if (customElements.get('mix-match-slider')) return;

  customElements.define('mix-match-slider', class extends HTMLElement {
    constructor() {
      super();
      this.flkty = null;
      this.nav = null;
      this.onResizeCallback = () => this.onResize();
    }

    connectedCallback() {
      this.checkSize();
      document.addEventListener('theme:resize:width', this.onResizeCallback);
    }

    initSlider() {
      if (this.flkty) return;

      this.flkty = new window.theme.Flickity(this, {
        cellSelector: '[data-item]',
        prevNextButtons: true,
        pageDots: true,
        wrapAround: false,
        contain: false,
        cellAlign: 'left',
        percentPosition: false,
        adaptiveHeight: false,
        on: {
          ready: () => {
            requestAnimationFrame(() => {
              this.flkty && this.flkty.resize();
              this._buildNav();
            });
          }
        }
      });
    }

    _buildNav() {
      // Remove stale nav if present
      if (this.nav) {
        this.nav.remove();
        this.nav = null;
      }

      const prevBtn = this.querySelector('.flickity-prev-next-button.previous');
      const nextBtn = this.querySelector('.flickity-prev-next-button.next');
      const dots = this.querySelector('.flickity-page-dots');

      if (!prevBtn && !nextBtn && !dots) return;

      const nav = document.createElement('div');
      nav.className = 'mix-match__nav';

      if (prevBtn) nav.appendChild(prevBtn);
      if (dots) nav.appendChild(dots);
      if (nextBtn) nav.appendChild(nextBtn);

      this.insertAdjacentElement('afterend', nav);
      this.nav = nav;
    }

    _restoreNavToSlider() {
      if (!this.nav) return;
      const btns = this.nav.querySelectorAll('.flickity-prev-next-button');
      const dots = this.nav.querySelector('.flickity-page-dots');
      btns.forEach(b => this.appendChild(b));
      if (dots) this.appendChild(dots);
      this.nav.remove();
      this.nav = null;
    }

    destroySlider() {
      if (this.flkty) {
        this._restoreNavToSlider();
        this.flkty.destroy();
        this.flkty = null;
      }
    }

    onResize() {
      this.checkSize();
    }

    checkSize() {
      if (window.innerWidth < window.theme.sizes.small) {
        this.initSlider();
      } else {
        this.destroySlider();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('theme:resize:width', this.onResizeCallback);
      this.destroySlider();
    }
  });
}();
